import { Component } from '@angular/core';
import { LoadingController, Platform, ToastController } from '@ionic/angular';
import { BaseComponent } from '../../base.component';
import { Router } from '@angular/router';
import { getAccountId, getToken } from '../../service/base.service';
import { VendasService } from 'src/app/shared/service/vendas/vendas.service';
import { BarcodeScanner  } from '@awesome-cordova-plugins/barcode-scanner';
import { environment } from 'src/environments/environment';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'cmp-validar-voucher',
  templateUrl: './validar-voucher.component.html',
  styleUrls: [
    './validar-voucher.component.scss',
  ]
})
export class ValidarVoucherComponent extends BaseComponent {
  theme = environment.theme_name;
  voucher: string;

  constructor(
    private platform: Platform, 
    public router: Router,
    public toastController: ToastController,
    public messageService: MessageService,
    public loadingController: LoadingController,
    private service: VendasService){
    super(router, toastController, loadingController);
  }

  ngOnInit(): void {

  }

  consultarVoucher(){
    const token = getToken();
    const accountId = getAccountId();
    this.service.consultaVoucher(token, accountId, this.voucher).then((resultado) =>{
      if(resultado){
        if(resultado.ok === false){
          this.showErrorMessage({
            title: 'Voucher não encontrado',
            message: resultado.msg
          })
        } else {
          this.showSuccessMessage({
            title: 'Voucher validado com sucesso',
            message: 'Veja todos voucher validados no menu de Vendas no seu Perfil',
          });
        }
      }
      console.log(resultado);
    }).catch((ex) =>{

    });
  }

  async lerQrCode() {
    const data = await BarcodeScanner.scan();

    try {
      const url = new URL(data.text);
      const voucher = url.searchParams.get('voucherCode');

      if (voucher){
        this.voucher = voucher;
      } else {
        this.message('Voucher não encontrado');
      }
    } catch (e) {
      console.log(e);
      this.message('Voucher não encontrado');
    }
  }

  isMobileNativeDevice() {
    return this.platform.is('mobile');
  }
}
